import React, { useState } from "react";
import styled from "styled-components";
import HeroSection from "./component/HeroSection";
import ServiveSwiper from "./component/ServiveSwiper";
import NewsInsightsSwiper from "./component/NewsInsightsSwiper";
const StyledParagraph = styled.p`
  font-size: 16px;
  line-height: 1.6;
  color: #333;
  max-width: 600px;
`;

const StyledFirstLetter = styled.span`
  font-size: 40px;
  font-weight: bold;
  color: #2a2a2a;
  float: left;
  line-height: 1;
  margin-right: 5px;
`;

const faqs = [
  {
    id: 1,
    question: "What services does Burooj Properties offer?",
    answer: `Burooj Properties provides comprehensive real estate solutions, including property management, 
facility management, buy and sell facilitation, and investment advisory services. We focus on 
maximizing rental income and optimizing asset value for our clients.`,
  },
  {
    id: 2,
    question: "Why should I choose Burooj for my business needs?",
    answer: `Burooj has a proven track record of success, market leadership in Oman and the GCC, a 
commitment to innovation, a focus on sustainability, and strong global partnerships. We create 
opportunities that redefine industries`,
  },
  {
    id: 3,
    question: "What types of investments does Burooj Investments focus on?",
    answer: `Burooj Investments specializes in private equity, asset management, and 
sustainable investing. We prioritize high-growth startups and ESG-driven opportunities to create 
lasting wealth`,
  },
  {
    id: 4,
    question: "How does Burooj Trading support SMEs in Oman?",
    answer: `Burooj Trading assists SMEs by providing efficient product sourcing and distribution, 
competitive pricing, and embedded supply chain finance options. We aim to facilitate market 
entry and expansion for innovative products in Oman.`,
  },
  {
    id: 5,
    question:
      "How can I stay updated on Burooj’s latest projects and initiatives?",
    answer: `You can stay updated by subscribing to our newsletter on our website or following us on our 
social media channels. We regularly share news about our projects, investment opportunities, and
industry insights`,
  },
  {
    id: 6,
    question:
      "How does Burooj ensure sustainable practices in its operations?",
    answer: `Sustainability is embedded in our business strategies. We focus on environmentally friendly 
practices in all our services, including sustainable investments and facility management solutions
that prioritize energy efficiency`,
  },
];
const Home = () => {
  const [activeId, setActiveId] = useState(null);

  const toggleFAQ = (id) => {
    setActiveId(activeId === id ? null : id);
  };
  return (
    <div className="elementor elementor-7626">
      <HeroSection />
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-d519741 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
        data-id="d519741"
        data-element_type="section"
      >
        <div className="elementor-container elementor-column-gap-wide">
          <div
            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-b84cd75"
            data-id="b84cd75"
            data-element_type="column"
          >
            <div className="elementor-widget-wrap ">
              <div className="e-con-inner" style={{ display: "flex" }}>
                <div
                  className="elementor-element elementor-element-c75a63e e-con-full e-flex e-con e-child"
                  data-id="c75a63e"
                  data-element_type="container"
                  data-settings='{"_ha_eqh_enable":false}'
                >
                  <div
                    className="elementor-element elementor-element-725ff07 elementor-widget elementor-widget-heading"
                    data-id="725ff07"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <div className="elementor-widget-container">
                      <div
                        className="elementor-heading-title elementor-size-default"
                        style={{ marginBottom: "20px" }}
                      >
                        Welcome to Burooj – Investing in the Future
                      </div>
                    </div>
                    {/* <div className="elementor-widget-container">
                      <h2
                        className="elementor-heading-title elementor-size-default"
                        style={{
                          fontSize: "14px",
                          fontWeight: "600",
                          fontFamily: "Noto Serif Georgian, Sans-serif",
                          color: "#2a2a2ab3",
                        }}
                      >
                        Welcome to Burooj – Investing in the Future
                      </h2>{" "}
                    </div> */}
                  </div>
                  <div
                    className="elementor-element elementor-element-640bd71 elementor-widget elementor-widget-heading"
                    data-id="640bd71"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <div className="elementor-widget-container">
                      <h2 className="elementor-heading-title elementor-size-default">
                        Building the present, investing in the future.
                      </h2>{" "}
                    </div>
                    {/* <div className="elementor-widget-container">
                      <h2
                        className="elementor-heading-title elementor-size-default"
                        style={{
                          fontSize: "30px",
                          fontWeight: "600",
                          lineHeight: "40px",
                          fontFamily: "Noto Serif Georgian, Sans-serif",
                          color: "#535353",
                        }}
                      >
                        Building the present, <br /> investing in the future.
                      </h2>{" "}
                    </div> */}
                  </div>
                </div>
                <div
                  className="elementor-element elementor-element-213ebb0 e-con-full e-flex e-con e-child"
                  data-id="213ebb0"
                  data-element_type="container"
                  data-settings='{"_ha_eqh_enable":false}'
                >
                  <div
                    className="elementor-element elementor-element-93edefa elementor-widget__width-initial elementor-drop-cap-yes elementor-drop-cap-view-default elementor-widget elementor-widget-text-editor"
                    data-id="93edefa"
                    data-element_type="widget"
                    data-settings='{"drop_cap":"yes"}'
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <StyledParagraph>
                        <StyledFirstLetter>At</StyledFirstLetter>
                         Burooj, we don’t just invest—we create <br />{" "}
                        opportunities that redefine industries. As a diversified
                        conglomerate, we operate at the intersection of
                        innovation, strategy, and economic growth, shaping
                        markets across Oman and the GCC region. Since our
                        inception in 2004, we have evolved into a powerhouse of
                        investments, engineering solutions, real estate
                        developments, and trading partnerships with global
                        brands.
                      </StyledParagraph>{" "}
                    </div>
                  </div>
                  <div
                    className="elementor-element elementor-element-7bed2fe elementor-widget__width-initial elementor-widget elementor-widget-text-editor"
                    data-id="7bed2fe"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p style={{ fontSize: "15px" }}>
                        From pioneering investment strategies to delivering
                        world-class engineering solutions, Burooj has been
                        at the forefront of Oman’s economic progress. Our
                        portfolio spans key sectors, ensuring we drive impactful
                        change and sustainable success. We are not just part of
                        the market— we actively shape it.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section
       className="elementor-section elementor-top-section elementor-element elementor-element-9d00d6f elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
       data-id="9d00d6f"
       data-element_type="section"
     >
       <div className="elementor-container elementor-column-gap-custom">
         <div
           className="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-e24fb0d"
           data-id="e24fb0d"
           data-element_type="column"
         >
           <div className="elementor-widget-wrap elementor-element-populated">
             <div
               className="elementor-element elementor-element-bee459f cmsmasters-featured-box__graphic-align-left cmsmasters-featured-box__graphic-align-mobile-center cmsmasters-featured-box__graphic-position-column cmsmasters-featured-box__graphic-position-tablet-column cmsmasters-featured-box__graphic-position-mobile-column cmsmasters-featured-box__both cmsmasters-featured-box__text-valign-middle cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-featured-box"
               data-id="bee459f"
               data-element_type="widget"
               data-widget_type="cmsmasters-featured-box.default"
             >
               <div className="elementor-widget-container">
                 <a
                   href="https://multibank.cmsmasters.net/classic/cmsms_service/mobile-banking/"
                   className="elementor-widget-cmsmasters-featured-box__wrapper"
                 >
                   <div className="elementor-widget-cmsmasters-featured-box__content">
                     <div className="elementor-widget-cmsmasters-featured-box__content-vertical-inner">
                       <div className="elementor-widget-cmsmasters-featured-box__graphic-wrapper elementor-widget-cmsmasters-featured-box__content-item elementor-widget-cmsmasters-featured-box__icon">
                         <div className="elementor-widget-cmsmasters-featured-box__icon-wrap elementor-widget-cmsmasters-featured-box__graphic-item">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-smartphone-1"></i>
                         </div>
                       </div>
                       <div className="elementor-widget-cmsmasters-featured-box__type-wrap elementor-widget-cmsmasters-featured-box__content-item">
                         <div className="elementor-widget-cmsmasters-featured-box__button-wrapper elementor-widget-cmsmasters-featured-box__content-item">
                           <span className="elementor-widget-cmsmasters-featured-box__button elementor-widget-cmsmasters-featured-box__content-item cmsmasters-theme-button elementor-widget-cmsmasters-featured-box__button-icon-right">
                             <span className="elementor-widget-cmsmasters-featured-box__button-icon-default elementor-widget-cmsmasters-featured-box__button-icon- elementor-widget-cmsmasters-featured-box__button-icon">
                               <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-right"></i>
                             </span>
                             Banking
                           </span>
                         </div>
                       </div>
                     </div>
                   </div>
                 </a>
               </div>
             </div>
           </div>
         </div>

         <div
           className="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-6e10dfb"
           data-id="6e10dfb"
           data-element_type="column"
         >
           <div className="elementor-widget-wrap elementor-element-populated">
             <div
               className="elementor-element elementor-element-aeff6ef cmsmasters-featured-box__graphic-align-left cmsmasters-featured-box__graphic-align-mobile-center cmsmasters-featured-box__graphic-position-column cmsmasters-featured-box__graphic-position-tablet-column cmsmasters-featured-box__graphic-position-mobile-column cmsmasters-featured-box__both cmsmasters-featured-box__text-valign-middle cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-featured-box"
               data-id="aeff6ef"
               data-element_type="widget"
               data-widget_type="cmsmasters-featured-box.default"
             >
               <div className="elementor-widget-container">
                 <a
                   href="https://multibank.cmsmasters.net/classic/cmsms_service/checking-accounts/"
                   className="elementor-widget-cmsmasters-featured-box__wrapper"
                 >
                   <div className="elementor-widget-cmsmasters-featured-box__content">
                     <div className="elementor-widget-cmsmasters-featured-box__content-vertical-inner">
                       <div className="elementor-widget-cmsmasters-featured-box__graphic-wrapper elementor-widget-cmsmasters-featured-box__content-item elementor-widget-cmsmasters-featured-box__icon">
                         <div className="elementor-widget-cmsmasters-featured-box__icon-wrap elementor-widget-cmsmasters-featured-box__graphic-item">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-check"></i>
                         </div>
                       </div>
                       <div className="elementor-widget-cmsmasters-featured-box__type-wrap elementor-widget-cmsmasters-featured-box__content-item">
                         <div className="elementor-widget-cmsmasters-featured-box__button-wrapper elementor-widget-cmsmasters-featured-box__content-item">
                           <span className="elementor-widget-cmsmasters-featured-box__button elementor-widget-cmsmasters-featured-box__content-item cmsmasters-theme-button elementor-widget-cmsmasters-featured-box__button-icon-right">
                             <span className="elementor-widget-cmsmasters-featured-box__button-icon-default elementor-widget-cmsmasters-featured-box__button-icon- elementor-widget-cmsmasters-featured-box__button-icon">
                               <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-right"></i>
                             </span>
                             Checking
                           </span>
                         </div>
                       </div>
                     </div>
                   </div>
                 </a>
               </div>
             </div>
           </div>
         </div>

         <div
           className="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-dea11ed"
           data-id="dea11ed"
           data-element_type="column"
         >
           <div className="elementor-widget-wrap elementor-element-populated">
             <div
               className="elementor-element elementor-element-b05ed89 cmsmasters-featured-box__graphic-align-left cmsmasters-featured-box__graphic-align-mobile-center cmsmasters-featured-box__graphic-position-column cmsmasters-featured-box__graphic-position-tablet-column cmsmasters-featured-box__graphic-position-mobile-column cmsmasters-featured-box__both cmsmasters-featured-box__text-valign-middle cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-featured-box"
               data-id="b05ed89"
               data-element_type="widget"
               data-widget_type="cmsmasters-featured-box.default"
             >
               <div className="elementor-widget-container">
                 <a
                   href="https://multibank.cmsmasters.net/classic/cmsms_service/credit-cards/"
                   className="elementor-widget-cmsmasters-featured-box__wrapper"
                 >
                   <div className="elementor-widget-cmsmasters-featured-box__content">
                     <div className="elementor-widget-cmsmasters-featured-box__content-vertical-inner">
                       <div className="elementor-widget-cmsmasters-featured-box__graphic-wrapper elementor-widget-cmsmasters-featured-box__content-item elementor-widget-cmsmasters-featured-box__icon">
                         <div className="elementor-widget-cmsmasters-featured-box__icon-wrap elementor-widget-cmsmasters-featured-box__graphic-item">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-credit-card-2"></i>
                         </div>
                       </div>
                       <div className="elementor-widget-cmsmasters-featured-box__type-wrap elementor-widget-cmsmasters-featured-box__content-item">
                         <div className="elementor-widget-cmsmasters-featured-box__button-wrapper elementor-widget-cmsmasters-featured-box__content-item">
                           <span className="elementor-widget-cmsmasters-featured-box__button elementor-widget-cmsmasters-featured-box__content-item cmsmasters-theme-button elementor-widget-cmsmasters-featured-box__button-icon-right">
                             <span className="elementor-widget-cmsmasters-featured-box__button-icon-default elementor-widget-cmsmasters-featured-box__button-icon- elementor-widget-cmsmasters-featured-box__button-icon">
                               <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-right"></i>
                             </span>
                             Payment Cards
                           </span>
                         </div>
                       </div>
                     </div>
                   </div>
                 </a>
               </div>
             </div>
           </div>
         </div>

         <div
           className="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-403a73b"
           data-id="403a73b"
           data-element_type="column"
         >
           <div className="elementor-widget-wrap elementor-element-populated">
             <div
               className="elementor-element elementor-element-c57a072 cmsmasters-featured-box__graphic-align-left cmsmasters-featured-box__graphic-align-mobile-center cmsmasters-featured-box__graphic-position-column cmsmasters-featured-box__graphic-position-tablet-column cmsmasters-featured-box__graphic-position-mobile-column cmsmasters-featured-box__both cmsmasters-featured-box__text-valign-middle cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-featured-box"
               data-id="c57a072"
               data-element_type="widget"
               data-widget_type="cmsmasters-featured-box.default"
             >
               <div className="elementor-widget-container">
                 <a
                   href="https://multibank.cmsmasters.net/classic/cmsms_service/savings-accounts/"
                   className="elementor-widget-cmsmasters-featured-box__wrapper"
                 >
                   <div className="elementor-widget-cmsmasters-featured-box__content">
                     <div className="elementor-widget-cmsmasters-featured-box__content-vertical-inner">
                       <div className="elementor-widget-cmsmasters-featured-box__graphic-wrapper elementor-widget-cmsmasters-featured-box__content-item elementor-widget-cmsmasters-featured-box__icon">
                         <div className="elementor-widget-cmsmasters-featured-box__icon-wrap elementor-widget-cmsmasters-featured-box__graphic-item">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-piggy-bank"></i>
                         </div>
                       </div>
                       <div className="elementor-widget-cmsmasters-featured-box__type-wrap elementor-widget-cmsmasters-featured-box__content-item">
                         <div className="elementor-widget-cmsmasters-featured-box__button-wrapper elementor-widget-cmsmasters-featured-box__content-item">
                           <span className="elementor-widget-cmsmasters-featured-box__button elementor-widget-cmsmasters-featured-box__content-item cmsmasters-theme-button elementor-widget-cmsmasters-featured-box__button-icon-right">
                             <span className="elementor-widget-cmsmasters-featured-box__button-icon-default elementor-widget-cmsmasters-featured-box__button-icon- elementor-widget-cmsmasters-featured-box__button-icon">
                               <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-right"></i>
                             </span>
                             Savings
                           </span>
                         </div>
                       </div>
                     </div>
                   </div>
                 </a>
               </div>
             </div>
           </div>
         </div>

         <div
           className="elementor-column elementor-col-20 elementor-top-column elementor-element elementor-element-6adfe8c elementor-hidden-mobile"
           data-id="6adfe8c"
           data-element_type="column"
         >
           <div className="elementor-widget-wrap elementor-element-populated">
             <div
               className="elementor-element elementor-element-f70bf35 cmsmasters-featured-box__graphic-align-left cmsmasters-featured-box__graphic-align-mobile-left cmsmasters-featured-box__graphic-position-column cmsmasters-featured-box__graphic-position-tablet-column cmsmasters-featured-box__graphic-position-mobile-column cmsmasters-featured-box__both cmsmasters-featured-box__text-valign-middle cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-featured-box"
               data-id="f70bf35"
               data-element_type="widget"
               data-widget_type="cmsmasters-featured-box.default"
             >
               <div className="elementor-widget-container">
                 <a
                   href="https://multibank.cmsmasters.net/classic/cmsms_service/mortgages/"
                   className="elementor-widget-cmsmasters-featured-box__wrapper"
                 >
                   <div className="elementor-widget-cmsmasters-featured-box__content">
                     <div className="elementor-widget-cmsmasters-featured-box__content-vertical-inner">
                       <div className="elementor-widget-cmsmasters-featured-box__graphic-wrapper elementor-widget-cmsmasters-featured-box__content-item elementor-widget-cmsmasters-featured-box__icon">
                         <div className="elementor-widget-cmsmasters-featured-box__icon-wrap elementor-widget-cmsmasters-featured-box__graphic-item">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-mortgage-loan-1"></i>
                         </div>
                       </div>
                       <div className="elementor-widget-cmsmasters-featured-box__type-wrap elementor-widget-cmsmasters-featured-box__content-item">
                         <div className="elementor-widget-cmsmasters-featured-box__button-wrapper elementor-widget-cmsmasters-featured-box__content-item">
                           <span className="elementor-widget-cmsmasters-featured-box__button elementor-widget-cmsmasters-featured-box__content-item cmsmasters-theme-button elementor-widget-cmsmasters-featured-box__button-icon-right">
                             <span className="elementor-widget-cmsmasters-featured-box__button-icon-default elementor-widget-cmsmasters-featured-box__button-icon- elementor-widget-cmsmasters-featured-box__button-icon">
                               <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-right"></i>
                             </span>
                             Mortgage
                           </span>
                         </div>
                       </div>
                     </div>
                   </div>
                 </a>
               </div>
             </div>
           </div>
         </div>
       </div>
     </section> */}
      <ServiveSwiper />
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-c7dbce1 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
        data-id="c7dbce1"
        data-element_type="section"
      >
        <div className="elementor-container elementor-column-gap-wide">
          <div
            className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-5673ca3"
            data-id="5673ca3"
            data-element_type="column"
          >
            <div className="elementor-widget-wrap elementor-element-populated">
              <div
                className="elementor-element elementor-element-c0694a5 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-image"
                data-id="c0694a5"
                data-element_type="widget"
                data-widget_type="image.default"
              >
                <div className="elementor-widget-container">
                  <img
                    loading="lazy"
                    decoding="async"
                    width="470"
                    height="640"
                    src="/imges/home-2-1.jpg"
                     style={{borderRadius:"20px"}}
                    className="attachment-full size-full wp-image-1478 cmsmasters_img cmsmasters-lazyload lazyloaded"
                    alt=""
                    data-sizes="(max-width: 470px) 100vw, 470px"
                    data-src="/imges/home-2-1.jpg"
                    // data-srcset="/imges/home-2-1.jpg 470w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/home-2-1-220x300.jpg 220w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/home-2-1-30x41.jpg 30w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/home-2-1-7x10.jpg 7w"
                    // srcSet="/imges/home-2-1.jpg 470w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/home-2-1-220x300.jpg 220w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/home-2-1-30x41.jpg 30w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/home-2-1-7x10.jpg 7w"
                    sizes="(max-width: 470px) 100vw, 470px"
                  />
                </div>
              </div>
              <div
                className="elementor-element elementor-element-4eccb1a elementor-widget__width-initial elementor-widget-mobile__width-initial elementor-absolute cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-image"
                data-id="4eccb1a"
                data-element_type="widget"
                data-settings='{"_position":"absolute"}'
                data-widget_type="image.default"
              >
                <div className="elementor-widget-container">
                  {/* <img
                   loading="lazy"
                   decoding="async"
                   width="332"
                   height="240"
                   src="/imges/service/building@2x.png"
                   className="attachment-large size-large wp-image-8986 cmsmasters_img cmsmasters-lazyload lazyloaded"
                   alt=""
                   data-sizes="(max-width: 332px) 100vw, 332px"
                   // data-src="/imges/card-2-1.png"
                   // data-srcset="/imges/card-2-1.png 332w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/card-2-1-300x217.png 300w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/card-2-1-30x22.png 30w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/card-2-1-14x10.png 14w"
                   // srcSet="/imges/card-2-1.png 332w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/card-2-1-300x217.png 300w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/card-2-1-30x22.png 30w, https://multibank.cmsmasters.net/classic/wp-content/uploads/sites/8/2021/11/card-2-1-14x10.png 14w"
                   sizes="(max-width: 332px) 100vw, 332px"
                 /> */}
                </div>
              </div>
            </div>
          </div>
          <div
            className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-640772f elementor-hidden-tablet elementor-hidden-mobile"
            data-id="640772f"
            data-element_type="column"
          >
            <div className="elementor-widget-wrap"></div>
          </div>
          <div
            className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-696d8b1"
            data-id="696d8b1"
            data-element_type="column"
          >
            <div
              className="elementor-widget-wrap elementor-element-populated"
              style={{ marginTop: "50px" }}
            >
              <section
                className="elementor-section elementor-inner-section elementor-element elementor-element-7793b33 elementor-section-full_width elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                data-id="7793b33"
                data-element_type="section"
              >
                <div className="elementor-container elementor-column-gap-no">
                  <div
                    className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-7d4f2cb"
                    data-id="7d4f2cb"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-65496f5 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                        data-id="65496f5"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <div className="elementor-heading-title elementor-size-default">
                            Why Choose Burooj?
                          </div>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-bda417e cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                        data-id="bda417e"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            Experience the power of strategic investments with
                            Burooj.
                          </h2>
                        </div>
                      </div>
                      {/* <div
                       className="elementor-element elementor-element-2f31f5e cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                       data-id="2f31f5e"
                       data-element_type="widget"
                       data-widget_type="heading.default"
                     >
                       <div className="elementor-widget-container">
                         <p className="elementor-heading-title elementor-size-default">
                           Earn 50,000 bonus points and get 4X
                           points on travel
                         </p>
                       </div>
                     </div> */}
                      <div
                        className="elementor-element elementor-element-771bb7c cmsmasters-tab-list-mode-justify cmsmasters-list-item-alignment-center cmsmasters-list-ver-align-center cmsmasters-tabs-type-horizontal cmsmasters-icon-position-left cmsmasters-tabs-position-start cmsmasters-icon-view-default cmsmasters-pointer-none cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-tabs cmsmasters-widget-tabs"
                        data-id="771bb7c"
                        data-element_type="widget"
                        data-settings='{"tabs":[{"tab_title":"Signature Card","tab_content":null,"_id":"8d4c697","content_type":"section","saved_section":"71","saved_template":null,"tab_subtitle":"","tab_icon":{"value":"","library":""},"tab_custom_id":""},{"tab_title":"Platinum Card","tab_content":null,"_id":"2b271ec","content_type":"section","saved_section":"71","saved_template":null,"tab_subtitle":"","tab_icon":{"value":"","library":""},"tab_custom_id":""}],"tabs_type":"horizontal","default_tab":1}'
                        data-widget_type="cmsmasters-tabs.default"
                      >
                        <div className="elementor-widget-container">
                          <div className="cmsmasters-tabs" role="tablist">
                            {/* <div className="cmsmasters-tabs-list-wrapper">
                             <ul className="cmsmasters-tabs-list">
                               <li
                                 id="cmsmasters-tabs-list-item_1241"
                                 className="cmsmasters-tabs-list-item cmsmasters-animation active-tab"
                                 data-tab="1"
                               >
                                 <a
                                   href=""
                                   className="cmsmasters-tab-title"
                                 >
                                   <div className="cmsmasters-tab-title__text-wrap-outer">
                                     <div className="cmsmasters-tab-title__text-wrap">
                                       <h6 className="cmsmasters-tab-title__text ">
                                         Signature Card
                                       </h6>
                                     </div>
                                   </div>
                                 </a>
                               </li>
                               <li
                                 id="cmsmasters-tabs-list-item_1242"
                                 className="cmsmasters-tabs-list-item cmsmasters-animation"
                                 data-tab="2"
                               >
                                 <a
                                   href=""
                                   className="cmsmasters-tab-title"
                                 >
                                   <div className="cmsmasters-tab-title__text-wrap-outer">
                                     <div className="cmsmasters-tab-title__text-wrap">
                                       <h6 className="cmsmasters-tab-title__text ">
                                         Platinum Card
                                       </h6>
                                     </div>
                                   </div>
                                 </a>
                               </li>
                             </ul>
                           </div> */}
                            <div className="cmsmasters-tabs-wrap">
                              <div
                                id="cmsmasters-tab-content_1241"
                                className="cmsmasters-tab active-tab"
                                data-tab="1"
                                style={{ display: "block" }}
                              >
                                <div
                                  data-elementor-type="section"
                                  data-elementor-id="71"
                                  className="elementor elementor-71 cmsmasters-header-position-absolute-"
                                >
                                  <div className="elementor-inner">
                                    <div className="elementor-section-wrap">
                                      <section
                                        className="elementor-section elementor-top-section elementor-element elementor-element-6f9bb4cf elementor-section-full_width elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                                        data-id="6f9bb4cf"
                                        data-element_type="section"
                                      >
                                        <div className="elementor-container elementor-column-gap-no">
                                          <div
                                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-1de24663"
                                            data-id="1de24663"
                                            data-element_type="column"
                                          >
                                            <div className="elementor-widget-wrap elementor-element-populated">
                                              <div
                                                className="elementor-element elementor-element-50f65b7a cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                                                data-id="50f65b7a"
                                                data-element_type="widget"
                                                data-widget_type="heading.default"
                                              >
                                                {/* <div className="elementor-widget-container">
                                                 <h5 className="elementor-heading-title elementor-size-default">
                                                   Rewards &amp;
                                                   Benefits
                                                 </h5>
                                               </div> */}
                                              </div>
                                              <div
                                                className="elementor-element elementor-element-f3ab9f4 cmsmasters-widget-layout-row cmsmasters-widget-align-stretch cmsmasters-widget-direction-default cmsmasters-widget-marker-element-icon cmsmasters-widget-marker-view-default cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-icon-list cmsmasters-widget-icon-list"
                                                data-id="f3ab9f4"
                                                data-element_type="widget"
                                                data-widget_type="cmsmasters-icon-list.default"
                                              >
                                                <div className="elementor-widget-container">
                                                  <ul className="cmsmasters-widget-icon-list-items">
                                                    <li className="cmsmasters-widget-icon-list-item active-icon-item icon-text">
                                                      <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                                        <span className="cmsmasters-widget-icon-list-item-icon">
                                                          <span>
                                                            <i
                                                              aria-hidden="true"
                                                              className="cmsmsdemo-icon- cmsms-demo-icon-check-circle"
                                                            ></i>
                                                          </span>
                                                        </span>
                                                        <span className="cmsmasters-widget-icon-list-item-text-inner">
                                                          <span className="cmsmasters-widget-icon-list-item-text">
                                                          Proven Expertise: A strong track record of success across diverse industries, delivering impactful solutions and driving growth.
                                                          </span>
                                                        </span>
                                                      </span>
                                                    </li>
                                                    <li className="cmsmasters-widget-icon-list-item active-icon-item icon-text">
                                                      <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                                        <span className="cmsmasters-widget-icon-list-item-icon">
                                                          <span>
                                                            <i
                                                              aria-hidden="true"
                                                              className="cmsmsdemo-icon- cmsms-demo-icon-check-circle"
                                                            ></i>
                                                          </span>
                                                        </span>
                                                        <span className="cmsmasters-widget-icon-list-item-text-inner">
                                                          <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                                          Market Leadership: A well-established presence in Oman, with ongoing expansion across the GCC, solidifying our regional influence.
                                                          </span>
                                                        </span>
                                                      </span>
                                                    </li>
                                                    <li className="cmsmasters-widget-icon-list-item active-icon-item icon-text">
                                                      <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                                        <span className="cmsmasters-widget-icon-list-item-icon">
                                                          <span>
                                                            <i
                                                              aria-hidden="true"
                                                              className="cmsmsdemo-icon- cmsms-demo-icon-check-circle"
                                                            ></i>
                                                          </span>
                                                        </span>
                                                        <span className="cmsmasters-widget-icon-list-item-text-inner">
                                                          <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                                          Innovation-Driven: A steadfast commitment to cutting-edge solutions, leveraging technology and future-ready investments to stay ahead.
                                                          </span>
                                                        </span>
                                                      </span>
                                                    </li>
                                                    <li className="cmsmasters-widget-icon-list-item active-icon-item icon-text">
                                                      <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                                        <span className="cmsmasters-widget-icon-list-item-icon">
                                                          <span>
                                                            <i
                                                              aria-hidden="true"
                                                              className="cmsmsdemo-icon- cmsms-demo-icon-check-circle"
                                                            ></i>
                                                          </span>
                                                        </span>
                                                        <span className="cmsmasters-widget-icon-list-item-text-inner">
                                                          <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                                          Sustainability Focus: ESG principles deeply embedded in our business strategies, ensuring long-term environmental and social responsibility.
                                                          </span>
                                                        </span>
                                                      </span>
                                                    </li>
                                                    <li className="cmsmasters-widget-icon-list-item active-icon-item icon-text">
                                                      <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                                        <span className="cmsmasters-widget-icon-list-item-icon">
                                                          <span>
                                                            <i
                                                              aria-hidden="true"
                                                              className="cmsmsdemo-icon- cmsms-demo-icon-check-circle"
                                                            ></i>
                                                          </span>
                                                        </span>
                                                        <span className="cmsmasters-widget-icon-list-item-text-inner">
                                                          <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                                          Global Partnerships: Strategic collaborations with leading international brands and institutions, fostering innovation and excellence.
                                                          </span>
                                                        </span>
                                                      </span>
                                                    </li>
                                                  </ul>
                                                </div>
                                              </div>
                                              <div
                                                className="elementor-element elementor-element-49714717 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-button"
                                                data-id="49714717"
                                                data-element_type="widget"
                                                data-widget_type="cmsmasters-button.default"
                                              >
                                                <div className="elementor-widget-container">
                                                  <div className="elementor-widget-cmsmasters-button__button-container">
                                                    <div className="elementor-widget-cmsmasters-button__button-container-inner">
                                                      <a
                                                        href="/about"
                                                        className="cmsmasters-button-link elementor-widget-cmsmasters-button__button cmsmasters-icon-view- cmsmasters-icon-shape- cmsmasters-button-size-sm"
                                                        role="button"
                                                        style={{
                                                          border:
                                                            "1.5px solid #2a2a2a",
                                                        }}
                                                      >
                                                        <span className="elementor-widget-cmsmasters-button__content-wrapper cmsmasters-align-icon-">
                                                          <span className="elementor-widget-cmsmasters-button__text">
                                                            Discover More
                                                          </span>
                                                        </span>
                                                      </a>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </section>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                id="cmsmasters-tab-content_1242"
                                className="cmsmasters-tab"
                                data-tab="2"
                              >
                                <div
                                  data-elementor-type="section"
                                  data-elementor-id="71"
                                  className="elementor elementor-71 cmsmasters-header-position-absolute-"
                                >
                                  <div className="elementor-inner">
                                    <div className="elementor-section-wrap">
                                      <section
                                        className="elementor-section elementor-top-section elementor-element elementor-element-6f9bb4cf elementor-section-full_width elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                                        data-id="6f9bb4cf"
                                        data-element_type="section"
                                      >
                                        <div className="elementor-container elementor-column-gap-no">
                                          <div
                                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-1de24663"
                                            data-id="1de24663"
                                            data-element_type="column"
                                          >
                                            <div className="elementor-widget-wrap elementor-element-populated">
                                              <div
                                                className="elementor-element elementor-element-50f65b7a cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                                                data-id="50f65b7a"
                                                data-element_type="widget"
                                                data-widget_type="heading.default"
                                              >
                                                <div className="elementor-widget-container">
                                                  <h5 className="elementor-heading-title elementor-size-default">
                                                    Rewards &amp; Benefits
                                                  </h5>
                                                </div>
                                              </div>
                                              <div
                                                className="elementor-element elementor-element-f3ab9f4 cmsmasters-widget-layout-row cmsmasters-widget-align-stretch cmsmasters-widget-direction-default cmsmasters-widget-marker-element-icon cmsmasters-widget-marker-view-default cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-icon-list cmsmasters-widget-icon-list"
                                                data-id="f3ab9f4"
                                                data-element_type="widget"
                                                data-widget_type="cmsmasters-icon-list.default"
                                              >
                                                <div className="elementor-widget-container">
                                                  <ul className="cmsmasters-widget-icon-list-items">
                                                    <li className="cmsmasters-widget-icon-list-item active-icon-item">
                                                      <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                                        <span className="cmsmasters-widget-icon-list-item-icon">
                                                          <span>
                                                            <i
                                                              aria-hidden="true"
                                                              className="cmsmsdemo-icon- cmsms-demo-icon-check-circle"
                                                            ></i>
                                                          </span>
                                                        </span>
                                                        <span className="cmsmasters-widget-icon-list-item-text-inner">
                                                          <span className="cmsmasters-widget-icon-list-item-text">
                                                            Credit limit up to
                                                            $5,000
                                                          </span>
                                                        </span>
                                                      </span>
                                                    </li>
                                                    <li className="cmsmasters-widget-icon-list-item active-icon-item">
                                                      <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                                        <span className="cmsmasters-widget-icon-list-item-icon">
                                                          <span>
                                                            <i
                                                              aria-hidden="true"
                                                              className="cmsmsdemo-icon- cmsms-demo-icon-check-circle"
                                                            ></i>
                                                          </span>
                                                        </span>
                                                        <span className="cmsmasters-widget-icon-list-item-text-inner">
                                                          <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                                            Up to 5% cash back
                                                            on two categories
                                                            you choose
                                                          </span>
                                                        </span>
                                                      </span>
                                                    </li>
                                                    <li className="cmsmasters-widget-icon-list-item active-icon-item">
                                                      <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                                        <span className="cmsmasters-widget-icon-list-item-icon">
                                                          <span>
                                                            <i
                                                              aria-hidden="true"
                                                              className="cmsmsdemo-icon- cmsms-demo-icon-check-circle"
                                                            ></i>
                                                          </span>
                                                        </span>
                                                        <span className="cmsmasters-widget-icon-list-item-text-inner">
                                                          <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                                            Enjoy a 0% intro APR
                                                            on purchases and
                                                            balance transfers
                                                            for the first 12
                                                            billing cycles.
                                                          </span>
                                                        </span>
                                                      </span>
                                                    </li>
                                                  </ul>
                                                </div>
                                              </div>
                                              <div
                                                className="elementor-element elementor-element-49714717 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-button"
                                                data-id="49714717"
                                                data-element_type="widget"
                                                data-widget_type="cmsmasters-button.default"
                                              >
                                                <div className="elementor-widget-container">
                                                  <div className="elementor-widget-cmsmasters-button__button-container">
                                                    <div className="elementor-widget-cmsmasters-button__button-container-inner">
                                                      <a
                                                        href="/about/"
                                                        className="cmsmasters-button-link elementor-widget-cmsmasters-button__button cmsmasters-icon-view- cmsmasters-icon-shape- cmsmasters-button-size-sm"
                                                        role="button"
                                                        style={{
                                                          border:
                                                            "1.5px solid #2a2a2a",
                                                        }}
                                                      >
                                                        <span className="elementor-widget-cmsmasters-button__content-wrapper cmsmasters-align-icon-">
                                                          <span className="elementor-widget-cmsmasters-button__text">
                                                            Discover More
                                                          </span>
                                                        </span>
                                                      </a>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </section>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-2e2fb5c elementor-reverse-tablet elementor-reverse-mobile elementor-section-boxed elementor-section-height-default cmsmasters-block-default"
        data-id="2e2fb5c"
        data-element_type="section"
      >
        <div className="elementor-container elementor-column-gap-wide">
          <div
            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-b643ec2"
            data-id="b643ec2"
            data-element_type="column"
            data-settings='{"background_background":"classic"}'
          >
            <div className="elementor-widget-wrap elementor-element-populated">
              <section
                className="elementor-section elementor-inner-section elementor-element elementor-element-e052d24 elementor-section-full_width elementor-section-content-middle elementor-reverse-tablet elementor-reverse-mobile elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                data-id="e052d24"
                data-element_type="section"
                data-settings='{"background_background":"classic"}'
              >
                <div className="elementor-container elementor-column-gap-no">
                  <div
                    className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-552b946"
                    data-id="552b946"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-a11e445 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                        data-id="a11e445"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <div
                            className="elementor-heading-title elementor-size-default"
                            style={{ color: "#191B22" }}
                          >
                            Partner with Us!
                          </div>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-4d65680 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                        data-id="4d65680"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            Let’s build the future together.
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-e056191 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                        data-id="e056191"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <p className="elementor-heading-title elementor-size-default">
                            At Burooj, we transform real estate into
                            living, breathing spaces that cater to the needs of
                            today and aspirations of tomorrow.
                          </p>
                        </div>
                      </div>

                      {/* <div
                       className="elementor-element elementor-element-8cc35c6 cmsmasters-button-mobile-align-justify elementor-widget__width-initial elementor-widget-mobile__width-inherit cmsmasters-icon-arrangement-together cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-button"
                       data-id="8cc35c6"
                       data-element_type="widget"
                       data-widget_type="cmsmasters-button.default"
                     >
                       <div className="elementor-widget-container">
                         <div className="elementor-widget-cmsmasters-button__button-container">
                           <div className="elementor-widget-cmsmasters-button__button-container-inner">
                             <a
                               href="https://multibank.cmsmasters.net/classic/contacts/"
                               className="cmsmasters-button-link elementor-widget-cmsmasters-button__button cmsmasters-icon-view-default cmsmasters-icon-shape- cmsmasters-button-size-sm"
                               role="button"
                             >
                               <span className="elementor-widget-cmsmasters-button__content-wrapper cmsmasters-align-icon-left">
                                 <span className="elementor-widget-cmsmasters-button__icon">
                                   <i
                                     aria-hidden="true"
                                     className="cmsmsdemo-icon- cmsms-demo-icon-apple"
                                   ></i>
                                 </span>
                                 <span className="elementor-widget-cmsmasters-button__text">
                                   App Store
                                 </span>
                               </span>
                             </a>
                           </div>
                         </div>
                       </div>
                     </div> */}
                      {/* <div
                       className="elementor-element elementor-element-12527a5 cmsmasters-button-mobile-align-justify elementor-widget__width-initial elementor-widget-mobile__width-inherit cmsmasters-icon-arrangement-together cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-button"
                       data-id="12527a5"
                       data-element_type="widget"
                       data-widget_type="cmsmasters-button.default"
                     >
                       <div className="elementor-widget-container">
                         <div className="elementor-widget-cmsmasters-button__button-container">
                           <div className="elementor-widget-cmsmasters-button__button-container-inner">
                             <a
                               href="https://multibank.cmsmasters.net/classic/contacts/"
                               className="cmsmasters-button-link elementor-widget-cmsmasters-button__button cmsmasters-icon-view-default cmsmasters-icon-shape- cmsmasters-button-size-sm"
                               role="button"
                             >
                               <span className="elementor-widget-cmsmasters-button__content-wrapper cmsmasters-align-icon-left">
                                 <span className="elementor-widget-cmsmasters-button__icon">
                                   <i
                                     aria-hidden="true"
                                     className="cmsmsdemo-icon- cmsms-demo-icon-google-play"
                                   ></i>
                                 </span>
                                 <span className="elementor-widget-cmsmasters-button__text">
                                   Google Play
                                 </span>
                               </span>
                             </a>
                           </div>
                         </div>
                       </div>
                     </div> */}
                    </div>
                    {/* End widget-wrap for left column */}
                  </div>
                  <div
                    className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-b588e3c"
                    data-id="b588e3c"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-8b3e7c8 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-image"
                        data-id="8b3e7c8"
                        data-element_type="widget"
                        data-widget_type="image.default"
                      >
                        <div className="elementor-widget-container">
                          <div
                            className="elementor-element elementor-element-f3ab9f4 cmsmasters-widget-layout-row cmsmasters-widget-align-stretch cmsmasters-widget-direction-default cmsmasters-widget-marker-element-icon cmsmasters-widget-marker-view-default cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-icon-list cmsmasters-widget-icon-list"
                            data-id="f3ab9f4"
                            data-element_type="widget"
                            data-widget_type="cmsmasters-icon-list.default"
                          >
                            <div className="elementor-widget-container">
                              <ul className="cmsmasters-widget-icon-list-items">
                                <li className="cmsmasters-widget-icon-list-item active-icon-item">
                                  <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                    <span className="cmsmasters-widget-icon-list-item-icon">
                                      <span>
                                        <i
                                          aria-hidden="true"
                                          className="cmsmsdemo-icon- cmsms-demo-icon-check-circle"
                                        ></i>
                                      </span>
                                    </span>
                                    <span className="cmsmasters-widget-icon-list-item-text-inner">
                                      <span className="cmsmasters-widget-icon-list-item-text">
                                        <span
                                          style={{
                                            fontWeight: "700",
                                            color: "#191b22",
                                          }}
                                        >
                                          A Legacy of Excellence{" "}
                                        </span>
                                        <br />
                                        Proven experience in delivering landmark
                                        developments.
                                      </span>
                                    </span>
                                  </span>
                                </li>
                                <li className="cmsmasters-widget-icon-list-item active-icon-item">
                                  <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                    <span className="cmsmasters-widget-icon-list-item-icon">
                                      <span>
                                        <i
                                          aria-hidden="true"
                                          className="cmsmsdemo-icon- cmsms-demo-icon-check-circle"
                                        ></i>
                                      </span>
                                    </span>
                                    <span className="cmsmasters-widget-icon-list-item-text-inner">
                                      <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                        <span
                                          style={{
                                            fontWeight: "700",
                                            color: "#191b22",
                                          }}
                                        >
                                          Innovative & Future-Ready Designs{" "}
                                        </span>
                                        <br /> Creating spaces that evolve with
                                        modern lifestyles.
                                      </span>
                                    </span>
                                  </span>
                                </li>
                                <li className="cmsmasters-widget-icon-list-item active-icon-item">
                                  <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                    <span className="cmsmasters-widget-icon-list-item-icon">
                                      <span>
                                        <i
                                          aria-hidden="true"
                                          className="cmsmsdemo-icon- cmsms-demo-icon-check-circle"
                                        ></i>
                                      </span>
                                    </span>
                                    <span className="cmsmasters-widget-icon-list-item-text-inner">
                                      <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                        <span
                                          style={{
                                            fontWeight: "700",
                                            color: "#191b22",
                                          }}
                                        >
                                          Sustainability & Smart Living{" "}
                                        </span>
                                        <br /> Integrating eco-friendly and
                                        tech-driven solutions.
                                      </span>
                                    </span>
                                  </span>
                                </li>
                                <li className="cmsmasters-widget-icon-list-item active-icon-item">
                                  <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                    <span className="cmsmasters-widget-icon-list-item-icon">
                                      <span>
                                        <i
                                          aria-hidden="true"
                                          className="cmsmsdemo-icon- cmsms-demo-icon-check-circle"
                                        ></i>
                                      </span>
                                    </span>
                                    <span className="cmsmasters-widget-icon-list-item-text-inner">
                                      <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                        <span
                                          style={{
                                            fontWeight: "700",
                                            color: "#191b22",
                                          }}
                                        >
                                          End-to-End Development Expertise{" "}
                                        </span>
                                        <br /> From concept to completion, we
                                        manage every aspect of the project.
                                      </span>
                                    </span>
                                  </span>
                                </li>
                                <li className="cmsmasters-widget-icon-list-item active-icon-item">
                                  <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                    <span className="cmsmasters-widget-icon-list-item-icon">
                                      <span>
                                        <i
                                          aria-hidden="true"
                                          className="cmsmsdemo-icon- cmsms-demo-icon-check-circle"
                                        ></i>
                                      </span>
                                    </span>
                                    <span className="cmsmasters-widget-icon-list-item-text-inner">
                                      <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                        <span
                                          style={{
                                            fontWeight: "700",
                                            color: "#191b22",
                                          }}
                                        >
                                          Commitment to Quality & Integrity{" "}
                                        </span>
                                        <br /> Building communities that stand
                                        the test of time.
                                      </span>
                                    </span>
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>

      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-2248440 elementor-hidden-mobile elementor-hidden-desktop elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
        data-id="2248440"
        data-element_type="section"
      >
        <div className="elementor-container elementor-column-gap-wide">
          <div
            className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-25a88c2"
            data-id="25a88c2"
            data-element_type="column"
          >
            <div className="elementor-widget-wrap elementor-element-populated">
              <div
                className="elementor-element elementor-element-08265ba elementor-widget__width-initial elementor-absolute elementor-view-default cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-icon"
                data-id="08265ba"
                data-element_type="widget"
                data-settings='{"_position":"absolute"}'
                data-widget_type="icon.default"
              >
                <div className="elementor-widget-container">
                  <div className="elementor-icon-wrapper">
                    <div className="elementor-icon">
                      <i
                        aria-hidden="true"
                        className="cmsmsdemo-icon- cmsms-demo-icon-calculator"
                      ></i>{" "}
                    </div>
                  </div>
                </div>
              </div>
              <section
                className="elementor-section elementor-inner-section elementor-element elementor-element-daa7447 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                data-id="daa7447"
                data-element_type="section"
              >
                <div className="elementor-container elementor-column-gap-no">
                  <div
                    className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-e236397"
                    data-id="e236397"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-517753b cmsmasters-icon-arrangement-together cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-button"
                        data-id="517753b"
                        data-element_type="widget"
                        data-widget_type="cmsmasters-button.default"
                      >
                        <div className="elementor-widget-container">
                          <div className="elementor-widget-cmsmasters-button__button-container">
                            <div className="elementor-widget-cmsmasters-button__button-container-inner">
                              <a
                                href="https://multibank.cmsmasters.net/classic/cmsms_service/credit-cards/"
                                className="cmsmasters-button-link elementor-widget-cmsmasters-button__button cmsmasters-icon-view-default cmsmasters-icon-shape- cmsmasters-button-size-sm"
                                role="button"
                              >
                                <span className="elementor-widget-cmsmasters-button__content-wrapper cmsmasters-align-icon-right">
                                  <span className="elementor-widget-cmsmasters-button__icon">
                                    <i
                                      aria-hidden="true"
                                      className="cmsmsdemo-icon- cmsms-demo-icon-arrow-right"
                                    ></i>
                                  </span>
                                  <span className="elementor-widget-cmsmasters-button__text">
                                    Rates &amp; calculators
                                  </span>
                                </span>
                              </a>
                            </div>
                          </div>{" "}
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-6876175 cmsmasters-widget-layout-row cmsmasters-widget-align-stretch cmsmasters-widget-direction-default cmsmasters-widget-marker-element-icon cmsmasters-widget-marker-view-default cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-icon-list cmsmasters-widget-icon-list"
                        data-id="6876175"
                        data-element_type="widget"
                        data-widget_type="cmsmasters-icon-list.default"
                      >
                        <div className="elementor-widget-container">
                          <ul className="cmsmasters-widget-icon-list-items">
                            <li className="cmsmasters-widget-icon-list-item">
                              <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                <span className="cmsmasters-widget-icon-list-item-text-inner active-link-item">
                                  <span className="cmsmasters-widget-icon-list-item-text">
                                    <a href="https://multibank.cmsmasters.net/classic/cmsms_service/credit-cards/">
                                      Rates &amp; fees
                                    </a>{" "}
                                  </span>
                                </span>
                              </span>
                            </li>
                            <li className="cmsmasters-widget-icon-list-item">
                              <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                <span className="cmsmasters-widget-icon-list-item-text-inner active-link-item">
                                  <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                    <a href="https://multibank.cmsmasters.net/classic/cmsms_service/wealth-management/">
                                      Tools &amp; calculators
                                    </a>{" "}
                                  </span>
                                </span>
                              </span>
                            </li>
                            <li className="cmsmasters-widget-icon-list-item">
                              <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                <span className="cmsmasters-widget-icon-list-item-text-inner active-link-item">
                                  <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                    <a href="https://multibank.cmsmasters.net/classic/cmsms_service/checking-accounts/">
                                      Savings calculator
                                    </a>{" "}
                                  </span>
                                </span>
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div
            className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-ff83fc2"
            data-id="ff83fc2"
            data-element_type="column"
          >
            <div className="elementor-widget-wrap elementor-element-populated">
              <div
                className="elementor-element elementor-element-dc66764 elementor-widget__width-initial elementor-absolute elementor-view-default cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-icon"
                data-id="dc66764"
                data-element_type="widget"
                data-settings='{"_position":"absolute"}'
                data-widget_type="icon.default"
              >
                <div className="elementor-widget-container">
                  <div className="elementor-icon-wrapper">
                    <div className="elementor-icon">
                      <i
                        aria-hidden="true"
                        className="cmsmsdemo-icon- cmsms-demo-icon-insurance"
                      ></i>{" "}
                    </div>
                  </div>
                </div>
              </div>
              <section
                className="elementor-section elementor-inner-section elementor-element elementor-element-cf88244 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                data-id="cf88244"
                data-element_type="section"
              >
                <div className="elementor-container elementor-column-gap-no">
                  <div
                    className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-0ef10ad"
                    data-id="0ef10ad"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-5f71cea cmsmasters-icon-arrangement-together cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-button"
                        data-id="5f71cea"
                        data-element_type="widget"
                        data-widget_type="cmsmasters-button.default"
                      >
                        <div className="elementor-widget-container">
                          <div className="elementor-widget-cmsmasters-button__button-container">
                            <div className="elementor-widget-cmsmasters-button__button-container-inner">
                              <a
                                href="https://multibank.cmsmasters.net/classic/cmsms_service/investments/"
                                className="cmsmasters-button-link elementor-widget-cmsmasters-button__button cmsmasters-icon-view-default cmsmasters-icon-shape- cmsmasters-button-size-sm"
                                role="button"
                              >
                                <span className="elementor-widget-cmsmasters-button__content-wrapper cmsmasters-align-icon-right">
                                  <span className="elementor-widget-cmsmasters-button__icon">
                                    <i
                                      aria-hidden="true"
                                      className="cmsmsdemo-icon- cmsms-demo-icon-arrow-right"
                                    ></i>
                                  </span>
                                  <span className="elementor-widget-cmsmasters-button__text">
                                    Insurance
                                  </span>
                                </span>
                              </a>
                            </div>
                          </div>{" "}
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-65925f1 cmsmasters-widget-layout-row cmsmasters-widget-align-stretch cmsmasters-widget-direction-default cmsmasters-widget-marker-element-icon cmsmasters-widget-marker-view-default cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-icon-list cmsmasters-widget-icon-list"
                        data-id="65925f1"
                        data-element_type="widget"
                        data-widget_type="cmsmasters-icon-list.default"
                      >
                        <div className="elementor-widget-container">
                          <ul className="cmsmasters-widget-icon-list-items">
                            <li className="cmsmasters-widget-icon-list-item">
                              <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                <span className="cmsmasters-widget-icon-list-item-text-inner active-link-item">
                                  <span className="cmsmasters-widget-icon-list-item-text">
                                    <a href="https://multibank.cmsmasters.net/classic/cmsms_service/mortgages/">
                                      Home insurance
                                    </a>{" "}
                                  </span>
                                </span>
                              </span>
                            </li>
                            <li className="cmsmasters-widget-icon-list-item">
                              <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                <span className="cmsmasters-widget-icon-list-item-text-inner active-link-item">
                                  <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                    <a href="https://multibank.cmsmasters.net/classic/cmsms_service/personal-loans/">
                                      Car insurance
                                    </a>{" "}
                                  </span>
                                </span>
                              </span>
                            </li>
                            <li className="cmsmasters-widget-icon-list-item">
                              <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                <span className="cmsmasters-widget-icon-list-item-text-inner active-link-item">
                                  <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                    <a href="https://multibank.cmsmasters.net/classic/cmsms_service/savings-accounts/">
                                      Health insurance
                                    </a>{" "}
                                  </span>
                                </span>
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-2248440 elementor-hidden-mobile elementor-hidden-desktop elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
        data-id="2248440"
        data-element_type="section"
      >
        <div className="elementor-container elementor-column-gap-wide">
          <div
            className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-25a88c2"
            data-id="25a88c2"
            data-element_type="column"
          >
            <div className="elementor-widget-wrap elementor-element-populated">
              <div
                className="elementor-element elementor-element-08265ba elementor-widget__width-initial elementor-absolute elementor-view-default cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-icon"
                data-id="08265ba"
                data-element_type="widget"
                data-settings='{"_position":"absolute"}'
                data-widget_type="icon.default"
              >
                <div className="elementor-widget-container">
                  <div className="elementor-icon-wrapper">
                    <div className="elementor-icon">
                      <i
                        aria-hidden="true"
                        className="cmsmsdemo-icon- cmsms-demo-icon-calculator"
                      ></i>{" "}
                    </div>
                  </div>
                </div>
              </div>
              <section
                className="elementor-section elementor-inner-section elementor-element elementor-element-daa7447 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                data-id="daa7447"
                data-element_type="section"
              >
                <div className="elementor-container elementor-column-gap-no">
                  <div
                    className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-e236397"
                    data-id="e236397"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-517753b cmsmasters-icon-arrangement-together cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-button"
                        data-id="517753b"
                        data-element_type="widget"
                        data-widget_type="cmsmasters-button.default"
                      >
                        <div className="elementor-widget-container">
                          <div className="elementor-widget-cmsmasters-button__button-container">
                            <div className="elementor-widget-cmsmasters-button__button-container-inner">
                              <a
                                href="https://multibank.cmsmasters.net/classic/cmsms_service/credit-cards/"
                                className="cmsmasters-button-link elementor-widget-cmsmasters-button__button cmsmasters-icon-view-default cmsmasters-icon-shape- cmsmasters-button-size-sm"
                                role="button"
                              >
                                <span className="elementor-widget-cmsmasters-button__content-wrapper cmsmasters-align-icon-right">
                                  <span className="elementor-widget-cmsmasters-button__icon">
                                    <i
                                      aria-hidden="true"
                                      className="cmsmsdemo-icon- cmsms-demo-icon-arrow-right"
                                    ></i>
                                  </span>
                                  <span className="elementor-widget-cmsmasters-button__text">
                                    Rates &amp; calculators
                                  </span>
                                </span>
                              </a>
                            </div>
                          </div>{" "}
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-6876175 cmsmasters-widget-layout-row cmsmasters-widget-align-stretch cmsmasters-widget-direction-default cmsmasters-widget-marker-element-icon cmsmasters-widget-marker-view-default cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-icon-list cmsmasters-widget-icon-list"
                        data-id="6876175"
                        data-element_type="widget"
                        data-widget_type="cmsmasters-icon-list.default"
                      >
                        <div className="elementor-widget-container">
                          <ul className="cmsmasters-widget-icon-list-items">
                            <li className="cmsmasters-widget-icon-list-item">
                              <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                <span className="cmsmasters-widget-icon-list-item-text-inner active-link-item">
                                  <span className="cmsmasters-widget-icon-list-item-text">
                                    <a href="https://multibank.cmsmasters.net/classic/cmsms_service/credit-cards/">
                                      Rates &amp; fees
                                    </a>{" "}
                                  </span>
                                </span>
                              </span>
                            </li>
                            <li className="cmsmasters-widget-icon-list-item">
                              <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                <span className="cmsmasters-widget-icon-list-item-text-inner active-link-item">
                                  <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                    <a href="https://multibank.cmsmasters.net/classic/cmsms_service/wealth-management/">
                                      Tools &amp; calculators
                                    </a>{" "}
                                  </span>
                                </span>
                              </span>
                            </li>
                            <li className="cmsmasters-widget-icon-list-item">
                              <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                <span className="cmsmasters-widget-icon-list-item-text-inner active-link-item">
                                  <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                    <a href="https://multibank.cmsmasters.net/classic/cmsms_service/checking-accounts/">
                                      Savings calculator
                                    </a>{" "}
                                  </span>
                                </span>
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div
            className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-ff83fc2"
            data-id="ff83fc2"
            data-element_type="column"
          >
            <div className="elementor-widget-wrap elementor-element-populated">
              <div
                className="elementor-element elementor-element-dc66764 elementor-widget__width-initial elementor-absolute elementor-view-default cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-icon"
                data-id="dc66764"
                data-element_type="widget"
                data-settings='{"_position":"absolute"}'
                data-widget_type="icon.default"
              >
                <div className="elementor-widget-container">
                  <div className="elementor-icon-wrapper">
                    <div className="elementor-icon">
                      <i
                        aria-hidden="true"
                        className="cmsmsdemo-icon- cmsms-demo-icon-insurance"
                      ></i>{" "}
                    </div>
                  </div>
                </div>
              </div>
              <section
                className="elementor-section elementor-inner-section elementor-element elementor-element-cf88244 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
                data-id="cf88244"
                data-element_type="section"
              >
                <div className="elementor-container elementor-column-gap-no">
                  <div
                    className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-0ef10ad"
                    data-id="0ef10ad"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-5f71cea cmsmasters-icon-arrangement-together cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-button"
                        data-id="5f71cea"
                        data-element_type="widget"
                        data-widget_type="cmsmasters-button.default"
                      >
                        <div className="elementor-widget-container">
                          <div className="elementor-widget-cmsmasters-button__button-container">
                            <div className="elementor-widget-cmsmasters-button__button-container-inner">
                              <a
                                href="https://multibank.cmsmasters.net/classic/cmsms_service/investments/"
                                className="cmsmasters-button-link elementor-widget-cmsmasters-button__button cmsmasters-icon-view-default cmsmasters-icon-shape- cmsmasters-button-size-sm"
                                role="button"
                              >
                                <span className="elementor-widget-cmsmasters-button__content-wrapper cmsmasters-align-icon-right">
                                  <span className="elementor-widget-cmsmasters-button__icon">
                                    <i
                                      aria-hidden="true"
                                      className="cmsmsdemo-icon- cmsms-demo-icon-arrow-right"
                                    ></i>
                                  </span>
                                  <span className="elementor-widget-cmsmasters-button__text">
                                    Insurance
                                  </span>
                                </span>
                              </a>
                            </div>
                          </div>{" "}
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-65925f1 cmsmasters-widget-layout-row cmsmasters-widget-align-stretch cmsmasters-widget-direction-default cmsmasters-widget-marker-element-icon cmsmasters-widget-marker-view-default cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-icon-list cmsmasters-widget-icon-list"
                        data-id="65925f1"
                        data-element_type="widget"
                        data-widget_type="cmsmasters-icon-list.default"
                      >
                        <div className="elementor-widget-container">
                          <ul className="cmsmasters-widget-icon-list-items">
                            <li className="cmsmasters-widget-icon-list-item">
                              <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                <span className="cmsmasters-widget-icon-list-item-text-inner active-link-item">
                                  <span className="cmsmasters-widget-icon-list-item-text">
                                    <a href="https://multibank.cmsmasters.net/classic/cmsms_service/mortgages/">
                                      Home insurance
                                    </a>{" "}
                                  </span>
                                </span>
                              </span>
                            </li>
                            <li className="cmsmasters-widget-icon-list-item">
                              <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                <span className="cmsmasters-widget-icon-list-item-text-inner active-link-item">
                                  <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                    <a href="https://multibank.cmsmasters.net/classic/cmsms_service/personal-loans/">
                                      Car insurance
                                    </a>{" "}
                                  </span>
                                </span>
                              </span>
                            </li>
                            <li className="cmsmasters-widget-icon-list-item">
                              <span className="cmsmasters-widget-icon-list-item-text-wrap">
                                <span className="cmsmasters-widget-icon-list-item-text-inner active-link-item">
                                  <span className="cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text cmsmasters-widget-icon-list-item-text">
                                    <a href="https://multibank.cmsmasters.net/classic/cmsms_service/savings-accounts/">
                                      Health insurance
                                    </a>{" "}
                                  </span>
                                </span>
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
      <NewsInsightsSwiper />
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-a1fe329 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
        data-id="a1fe329"
        data-element_type="section"
      >
        <div className="elementor-container elementor-column-gap-no">
          <div
            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-4590363"
            data-id={4590363}
            data-element_type="column"
          >
            <div className="elementor-widget-wrap elementor-element-populated">
              <div
                className="elementor-element elementor-element-b5739d0 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                data-id="b5739d0"
                data-element_type="widget"
                data-widget_type="heading.default"
              >
                <div className="elementor-widget-container">
                  <div className="elementor-heading-title elementor-size-default">
                    help center
                  </div>{" "}
                </div>
              </div>
              <div
                className="elementor-element elementor-element-4756c81 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                data-id="4756c81"
                data-element_type="widget"
                data-widget_type="heading.default"
              >
                <div className="elementor-widget-container">
                  <h2 className="elementor-heading-title elementor-size-default">
                    Frequently asked questions
                  </h2>{" "}
                </div>
              </div>
              <div
                className="elementor-element elementor-element-62f9aed cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-text-editor"
                data-id="62f9aed"
                data-element_type="widget"
                data-widget_type="text-editor.default"
              >
                <div className="elementor-widget-container">
                  <p>
                    Got a question about how we’re organised, applying to work
                    for us <br />
                    <a href="/">View more Q&amp;A here</a>
                  </p>{" "}
                </div>
              </div>
              <div
                className="elementor-element elementor-element-bbeff21 cmsmasters-title-alignment-left cmsmasters-item-icon-position-left cmsmasters-trigger-icon-view-default cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-toggles cmsmasters-widget-toggles"
                data-id="bbeff21"
                data-element_type="widget"
                data-settings='{"toggles":[{"toggle_title":"I&apos;m having trouble accessing my account online. What should I do?","toggle_content":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.","_id":"fea7400","content_type":"toggle-content","saved_section":null,"saved_template":null,"item_icon":{"value":"","library":""},"toggle_custom_id":""},{"toggle_title":"What is the address I mail my credit card payment to?","toggle_content":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.","_id":"81ec36f","content_type":"toggle-content","saved_section":null,"saved_template":null,"item_icon":{"value":"","library":""},"toggle_custom_id":""},{"toggle_title":"How do I dispute a charge on my account?","toggle_content":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.","_id":"aba9bfa","content_type":"toggle-content","saved_section":null,"saved_template":null,"item_icon":{"value":"","library":""},"toggle_custom_id":""},{"toggle_title":"How do I contact the payment assistance team?","toggle_content":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.","_id":"7f9978a","content_type":"toggle-content","saved_section":null,"saved_template":null,"item_icon":{"value":"","library":""},"toggle_custom_id":""},{"toggle_title":"How do I activate a card?","toggle_content":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.","_id":"7163114","content_type":"toggle-content","saved_section":null,"saved_template":null,"item_icon":{"value":"","library":""},"toggle_custom_id":""}],"type":"toggles"}'
                data-widget_type="cmsmasters-toggles.default"
              >
                <div className="elementor-widget-container">
                  <div
                    className="elementor-widget-cmsmasters-toggles__list"
                    role="tablist"
                  >
                    {faqs.map(({ id, question, answer }) => (
                      <div
                        key={id}
                        className={`elementor-widget-cmsmasters-toggles__item ${activeId === id ? "active-toggle" : ""
                          }`}
                      >
                        <h6
                          className={`elementor-widget-cmsmasters-toggles__title ${activeId === id ? "active-toggle" : ""
                            }`}
                          onClick={() => toggleFAQ(id)}
                        >
                          <a
                            className="elementor-widget-cmsmasters-toggles__title-link cmsmasters_enable_trigger_icon"
                            type="button"
                          >
                            {question}
                          </a>
                          <span className="elementor-widget-cmsmasters-toggles__title-text">
                            {activeId === id ? (
                              <span className="elementor-widget-cmsmasters-toggles__trigger-opened">
                                <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-up" />
                              </span>
                            ) : (
                              <span className="elementor-widget-cmsmasters-toggles__trigger-closed">
                                <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-down" />
                              </span>
                            )}
                          </span>
                        </h6>
                        {activeId === id && (
                          <div
                            id="elementor-widget-cmsmasters-toggles__content-1971"
                            className="elementor-widget-cmsmasters-toggles__content elementor-clearfix"
                            data-tab={1}
                            role="tabpanel"
                            aria-labelledby="elementor-tab-title-1971"
                            style={{
                              display: activeId === id ? "block" : "none",
                            }}
                          >
                            {answer}
                          </div>
                        )}
                      </div>
                    ))}
                    {/* <div className="elementor-widget-cmsmasters-toggles__item">
                     <h6
                       id="elementor-tab-title-1971"
                       className="elementor-widget-cmsmasters-toggles__title"
                       data-tab={1}
                       role="tab"
                       aria-controls="elementor-widget-cmsmasters-toggles__content-1971"
                       aria-expanded="false"
                     >
                       <a
                         className="elementor-widget-cmsmasters-toggles__title-link cmsmasters_enable_trigger_icon"
                         href="#"
                       >
                         <span className="elementor-widget-cmsmasters-toggles__title-text">
                           I'm having trouble accessing my account
                           online. What should I do?
                         </span>
                       </a>
                       <span
                         className="elementor-widget-cmsmasters-toggles__trigger"
                         aria-hidden="true"
                       >
                         <span className="elementor-widget-cmsmasters-toggles__trigger-closed">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-down" />
                         </span>
                         <span className="elementor-widget-cmsmasters-toggles__trigger-opened">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-up" />
                         </span>
                       </span>
                     </h6>
                     <div
                       id="elementor-widget-cmsmasters-toggles__content-1971"
                       className="elementor-widget-cmsmasters-toggles__content elementor-clearfix"
                       data-tab={1}
                       role="tabpanel"
                       aria-labelledby="elementor-tab-title-1971"
                     >
                       Lorem ipsum dolor sit amet, consectetur
                       adipiscing elit. Ut elit tellus, luctus nec
                       ullamcorper mattis, pulvinar dapibus leo.
                     </div>
                   </div>
                   <div className="elementor-widget-cmsmasters-toggles__item">
                     <h6
                       id="elementor-tab-title-1972"
                       className="elementor-widget-cmsmasters-toggles__title"
                       data-tab={2}
                       role="tab"
                       aria-controls="elementor-widget-cmsmasters-toggles__content-1972"
                       aria-expanded="false"
                     >
                       <a
                         className="elementor-widget-cmsmasters-toggles__title-link cmsmasters_enable_trigger_icon"
                         href="#"
                       >
                         <span className="elementor-widget-cmsmasters-toggles__title-text">
                           What is the address I mail my credit
                           card payment to?
                         </span>
                       </a>
                       <span
                         className="elementor-widget-cmsmasters-toggles__trigger"
                         aria-hidden="true"
                       >
                         <span className="elementor-widget-cmsmasters-toggles__trigger-closed">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-down" />
                         </span>
                         <span className="elementor-widget-cmsmasters-toggles__trigger-opened">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-up" />
                         </span>
                       </span>
                     </h6>
                     <div
                       id="elementor-widget-cmsmasters-toggles__content-1972"
                       className="elementor-widget-cmsmasters-toggles__content elementor-clearfix"
                       data-tab={2}
                       role="tabpanel"
                       aria-labelledby="elementor-tab-title-1972"
                     >
                       Lorem ipsum dolor sit amet, consectetur
                       adipiscing elit. Ut elit tellus, luctus nec
                       ullamcorper mattis, pulvinar dapibus leo.
                     </div>
                   </div>
                   <div className="elementor-widget-cmsmasters-toggles__item">
                     <h6
                       id="elementor-tab-title-1973"
                       className="elementor-widget-cmsmasters-toggles__title"
                       data-tab={3}
                       role="tab"
                       aria-controls="elementor-widget-cmsmasters-toggles__content-1973"
                       aria-expanded="false"
                     >
                       <a
                         className="elementor-widget-cmsmasters-toggles__title-link cmsmasters_enable_trigger_icon"
                         href="#"
                       >
                         <span className="elementor-widget-cmsmasters-toggles__title-text">
                           How do I dispute a charge on my account?
                         </span>
                       </a>
                       <span
                         className="elementor-widget-cmsmasters-toggles__trigger"
                         aria-hidden="true"
                       >
                         <span className="elementor-widget-cmsmasters-toggles__trigger-closed">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-down" />
                         </span>
                         <span className="elementor-widget-cmsmasters-toggles__trigger-opened">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-up" />
                         </span>
                       </span>
                     </h6>
                     <div
                       id="elementor-widget-cmsmasters-toggles__content-1973"
                       className="elementor-widget-cmsmasters-toggles__content elementor-clearfix"
                       data-tab={3}
                       role="tabpanel"
                       aria-labelledby="elementor-tab-title-1973"
                     >
                       Lorem ipsum dolor sit amet, consectetur
                       adipiscing elit. Ut elit tellus, luctus nec
                       ullamcorper mattis, pulvinar dapibus leo.
                     </div>
                   </div>
                   <div className="elementor-widget-cmsmasters-toggles__item">
                     <h6
                       id="elementor-tab-title-1974"
                       className="elementor-widget-cmsmasters-toggles__title"
                       data-tab={4}
                       role="tab"
                       aria-controls="elementor-widget-cmsmasters-toggles__content-1974"
                       aria-expanded="false"
                     >
                       <a
                         className="elementor-widget-cmsmasters-toggles__title-link cmsmasters_enable_trigger_icon"
                         href="#"
                       >
                         <span className="elementor-widget-cmsmasters-toggles__title-text">
                           How do I contact the payment assistance
                           team?
                         </span>
                       </a>
                       <span
                         className="elementor-widget-cmsmasters-toggles__trigger"
                         aria-hidden="true"
                       >
                         <span className="elementor-widget-cmsmasters-toggles__trigger-closed">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-down" />
                         </span>
                         <span className="elementor-widget-cmsmasters-toggles__trigger-opened">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-up" />
                         </span>
                       </span>
                     </h6>
                     <div
                       id="elementor-widget-cmsmasters-toggles__content-1974"
                       className="elementor-widget-cmsmasters-toggles__content elementor-clearfix"
                       data-tab={4}
                       role="tabpanel"
                       aria-labelledby="elementor-tab-title-1974"
                     >
                       Lorem ipsum dolor sit amet, consectetur
                       adipiscing elit. Ut elit tellus, luctus nec
                       ullamcorper mattis, pulvinar dapibus leo.
                     </div>
                   </div>
                   <div className="elementor-widget-cmsmasters-toggles__item">
                     <h6
                       id="elementor-tab-title-1975"
                       className="elementor-widget-cmsmasters-toggles__title"
                       data-tab={5}
                       role="tab"
                       aria-controls="elementor-widget-cmsmasters-toggles__content-1975"
                       aria-expanded="false"
                     >
                       <a
                         className="elementor-widget-cmsmasters-toggles__title-link cmsmasters_enable_trigger_icon"
                         href="#"
                       >
                         <span className="elementor-widget-cmsmasters-toggles__title-text">
                           How do I activate a card?
                         </span>
                       </a>
                       <span
                         className="elementor-widget-cmsmasters-toggles__trigger"
                         aria-hidden="true"
                       >
                         <span className="elementor-widget-cmsmasters-toggles__trigger-closed">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-down" />
                         </span>
                         <span className="elementor-widget-cmsmasters-toggles__trigger-opened">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-up" />
                         </span>
                       </span>
                     </h6>
                     <div
                       id="elementor-widget-cmsmasters-toggles__content-1975"
                       className="elementor-widget-cmsmasters-toggles__content elementor-clearfix"
                       data-tab={5}
                       role="tabpanel"
                       aria-labelledby="elementor-tab-title-1975"
                     >
                       Lorem ipsum dolor sit amet, consectetur
                       adipiscing elit. Ut elit tellus, luctus nec
                       ullamcorper mattis, pulvinar dapibus leo.
                     </div>
                   </div> */}
                  </div>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section
       className="elementor-section elementor-top-section elementor-element elementor-element-357e8b3 elementor-section-height-min-height elementor-section-items-stretch elementor-section-boxed elementor-section-height-default cmsmasters-block-default"
       data-id="357e8b3"
       data-element_type="section"
     >
       <div className="elementor-container elementor-column-gap-no">
         <div
           className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-51de299"
           data-id="51de299"
           data-element_type="column"
           data-settings='{"background_background":"classic"}'
         >
           <div className="elementor-widget-wrap elementor-element-populated">
             <div
               className="elementor-element elementor-element-ba5ab94 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
               data-id="ba5ab94"
               data-element_type="widget"
               data-widget_type="heading.default"
             >
               <div className="elementor-widget-container">
                 <h4 className="elementor-heading-title elementor-size-default">
                   Find my nearest branch or ATM
                 </h4>{" "}
               </div>
             </div>
             <div
               className="elementor-element elementor-element-21a5944 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-button"
               data-id="21a5944"
               data-element_type="widget"
               data-widget_type="cmsmasters-button.default"
             >
               <div className="elementor-widget-container">
                 <div className="elementor-widget-cmsmasters-button__button-container">
                   <div className="elementor-widget-cmsmasters-button__button-container-inner">
                     <a
                       href="https://multibank.cmsmasters.net/classic/contacts/"
                       className="cmsmasters-button-link elementor-widget-cmsmasters-button__button cmsmasters-icon-view- cmsmasters-icon-shape- cmsmasters-button-size-sm"
                       role="button"
                     >
                       <span className="elementor-widget-cmsmasters-button__content-wrapper cmsmasters-align-icon-">
                         <span className="elementor-widget-cmsmasters-button__text">
                           Search Now
                         </span>
                       </span>
                     </a>
                   </div>
                 </div>{" "}
               </div>
             </div>
           </div>
         </div>
         <div
           className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-00e9afd elementor-hidden-mobile cmsmasters-bg-hide-none cmsmasters-bg-hide-none"
           data-id="00e9afd"
           data-element_type="column"
           data-settings='{"background_background":"classic"}'
         >
           <div className="elementor-widget-wrap elementor-element-populated">
             <div
               className="elementor-element elementor-element-ed35cba cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-spacer"
               data-id="ed35cba"
               data-element_type="widget"
               data-widget_type="spacer.default"
             >
               <div className="elementor-widget-container">
                 <div className="elementor-spacer">
                   <div className="elementor-spacer-inner" />
                 </div>
               </div>
             </div>
           </div>
         </div>
         <div
           className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-aca6bcc"
           data-id="aca6bcc"
           data-element_type="column"
         >
           <div className="elementor-widget-wrap elementor-element-populated">
             <div
               className="elementor-element elementor-element-c9a281d cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
               data-id="c9a281d"
               data-element_type="widget"
               data-widget_type="heading.default"
             >
               <div className="elementor-widget-container">
                 <h4 className="elementor-heading-title elementor-size-default">
                   Foreign exchange rates
                 </h4>{" "}
               </div>
             </div>
             <section
               className="elementor-section elementor-inner-section elementor-element elementor-element-cb1d73f elementor-section-height-min-height elementor-section-content-middle elementor-section-boxed elementor-section-height-default cmsmasters-block-default"
               data-id="cb1d73f"
               data-element_type="section"
               data-settings='{"background_background":"classic"}'
             >
               <div className="elementor-container elementor-column-gap-default">
                 <div
                   className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-10ed897"
                   data-id="10ed897"
                   data-element_type="column"
                 >
                   <div className="elementor-widget-wrap elementor-element-populated">
                     <div
                       className="elementor-element elementor-element-46f47ff cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                       data-id="46f47ff"
                       data-element_type="widget"
                       data-widget_type="heading.default"
                     >
                       <div className="elementor-widget-container">
                         <h6 className="elementor-heading-title elementor-size-default">
                           Currency
                         </h6>{" "}
                       </div>
                     </div>
                   </div>
                 </div>
                 <div
                   className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-f766bd5"
                   data-id="f766bd5"
                   data-element_type="column"
                 >
                   <div className="elementor-widget-wrap elementor-element-populated">
                     <div
                       className="elementor-element elementor-element-a677a36 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                       data-id="a677a36"
                       data-element_type="widget"
                       data-widget_type="heading.default"
                     >
                       <div className="elementor-widget-container">
                         <h6 className="elementor-heading-title elementor-size-default">
                           Purchase
                         </h6>{" "}
                       </div>
                     </div>
                   </div>
                 </div>
                 <div
                   className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-5f1b9e5"
                   data-id="5f1b9e5"
                   data-element_type="column"
                 >
                   <div className="elementor-widget-wrap elementor-element-populated">
                     <div
                       className="elementor-element elementor-element-0295c57 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                       data-id="0295c57"
                       data-element_type="widget"
                       data-widget_type="heading.default"
                     >
                       <div className="elementor-widget-container">
                         <h6 className="elementor-heading-title elementor-size-default">
                           Selling
                         </h6>{" "}
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </section>
             <section
               className="elementor-section elementor-inner-section elementor-element elementor-element-6ff0378 elementor-section-height-min-height elementor-section-content-middle elementor-section-boxed elementor-section-height-default cmsmasters-block-default"
               data-id="6ff0378"
               data-element_type="section"
             >
               <div className="elementor-container elementor-column-gap-default">
                 <div
                   className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-338bee2"
                   data-id="338bee2"
                   data-element_type="column"
                 >
                   <div className="elementor-widget-wrap elementor-element-populated">
                     <div
                       className="elementor-element elementor-element-fc0c3b9 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                       data-id="fc0c3b9"
                       data-element_type="widget"
                       data-widget_type="heading.default"
                     >
                       <div className="elementor-widget-container">
                         <h6 className="elementor-heading-title elementor-size-default">
                           USD
                         </h6>{" "}
                       </div>
                     </div>
                   </div>
                 </div>
                 <div
                   className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-bc71b4e"
                   data-id="bc71b4e"
                   data-element_type="column"
                 >
                   <div className="elementor-widget-wrap elementor-element-populated">
                     <div
                       className="elementor-element elementor-element-f4591cd cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                       data-id="f4591cd"
                       data-element_type="widget"
                       data-widget_type="heading.default"
                     >
                       <div className="elementor-widget-container">
                         <div className="elementor-heading-title elementor-size-default">
                           74.55
                         </div>{" "}
                       </div>
                     </div>
                   </div>
                 </div>
                 <div
                   className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-aef460d"
                   data-id="aef460d"
                   data-element_type="column"
                 >
                   <div className="elementor-widget-wrap elementor-element-populated">
                     <div
                       className="elementor-element elementor-element-ab33cc1 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                       data-id="ab33cc1"
                       data-element_type="widget"
                       data-widget_type="heading.default"
                     >
                       <div className="elementor-widget-container">
                         <div className="elementor-heading-title elementor-size-default">
                           74.74
                         </div>{" "}
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </section>
             <section
               className="elementor-section elementor-inner-section elementor-element elementor-element-e4415c1 elementor-section-height-min-height elementor-section-content-middle elementor-section-boxed elementor-section-height-default cmsmasters-block-default"
               data-id="e4415c1"
               data-element_type="section"
             >
               <div className="elementor-container elementor-column-gap-default">
                 <div
                   className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-6a469be"
                   data-id="6a469be"
                   data-element_type="column"
                 >
                   <div className="elementor-widget-wrap elementor-element-populated">
                     <div
                       className="elementor-element elementor-element-b96280f cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                       data-id="b96280f"
                       data-element_type="widget"
                       data-widget_type="heading.default"
                     >
                       <div className="elementor-widget-container">
                         <h6 className="elementor-heading-title elementor-size-default">
                           EUR
                         </h6>{" "}
                       </div>
                     </div>
                   </div>
                 </div>
                 <div
                   className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-4792d84"
                   data-id="4792d84"
                   data-element_type="column"
                 >
                   <div className="elementor-widget-wrap elementor-element-populated">
                     <div
                       className="elementor-element elementor-element-103bf6f cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                       data-id="103bf6f"
                       data-element_type="widget"
                       data-widget_type="heading.default"
                     >
                       <div className="elementor-widget-container">
                         <div className="elementor-heading-title elementor-size-default">
                           83.60
                         </div>{" "}
                       </div>
                     </div>
                   </div>
                 </div>
                 <div
                   className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-ffdb451"
                   data-id="ffdb451"
                   data-element_type="column"
                 >
                   <div className="elementor-widget-wrap elementor-element-populated">
                     <div
                       className="elementor-element elementor-element-714df85 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                       data-id="714df85"
                       data-element_type="widget"
                       data-widget_type="heading.default"
                     >
                       <div className="elementor-widget-container">
                         <div className="elementor-heading-title elementor-size-default">
                           83.83
                         </div>{" "}
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </section>
             <div
               className="elementor-element elementor-element-fb62a96 cmsmasters-icon-arrangement-together cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-button"
               data-id="fb62a96"
               data-element_type="widget"
               data-widget_type="cmsmasters-button.default"
             >
               <div className="elementor-widget-container">
                 <div className="elementor-widget-cmsmasters-button__button-container">
                   <div className="elementor-widget-cmsmasters-button__button-container-inner">
                     <a
                       href="https://multibank.cmsmasters.net/classic/services/"
                       className="cmsmasters-button-link elementor-widget-cmsmasters-button__button cmsmasters-icon-view-default cmsmasters-icon-shape- cmsmasters-button-size-sm"
                       role="button"
                     >
                       <span className="elementor-widget-cmsmasters-button__content-wrapper cmsmasters-align-icon-right">
                         <span className="elementor-widget-cmsmasters-button__icon">
                           <i
                             aria-hidden="true"
                             className="cmsmsdemo-icon- cmsms-demo-icon-arrow-right"
                           />
                         </span>
                         <span className="elementor-widget-cmsmasters-button__text">
                           View More
                         </span>
                       </span>
                     </a>
                   </div>
                 </div>{" "}
               </div>
             </div>
           </div>
         </div>
       </div>
     </section> */}
    </div>
  );
};

export default Home;
